module.exports = __webpack_public_path__ + "img/WarningImg.d1b7bba2.svg";